import { render, staticRenderFns } from "./PowerWorkspace.vue?vue&type=template&id=394ea4fe"
import script from "./PowerWorkspace.vue?vue&type=script&lang=js"
export * from "./PowerWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports